import React from 'react';
import { useTranslatableField } from '../hooks/useTranslation';
import { Languages, Loader2 } from 'lucide-react';
import { Button } from './ui/button';

const TranslatableText = ({ 
  text, 
  as: Component = 'span', 
  className = '', 
  showToggle = true,
  autoTranslate = false,
  ...props 
}) => {
  const {
    displayText,
    originalText,
    showOriginal,
    toggleOriginal,
    isTranslating,
    hasTranslation,
  } = useTranslatableField(text, autoTranslate);

  if (!text) return null;

  return (
    <div className="inline">
      <Component className={className} {...props}>
        {isTranslating ? (
          <span className="inline-flex items-center gap-1">
            {text}
            <Loader2 className="w-3 h-3 animate-spin text-amber-400 inline ml-1" />
          </span>
        ) : (
          displayText
        )}
      </Component>
      {showToggle && hasTranslation && !isTranslating && (
        <Button
          variant="ghost"
          size="sm"
          onClick={toggleOriginal}
          className="ml-2 h-6 px-2 text-xs text-slate-400 hover:text-amber-400 inline-flex items-center gap-1"
          title={showOriginal ? 'Show translation' : 'Show original'}
        >
          <Languages className="w-3 h-3" />
          {showOriginal ? 'Translated' : 'Original'}
        </Button>
      )}
    </div>
  );
};

// Simpler version for lists where we don't want individual toggles
export const TranslatableSpan = ({ text, className = '', autoTranslate = false, ...props }) => {
  const { displayText, isTranslating } = useTranslatableField(text, autoTranslate);
  
  if (!text) return null;
  
  return (
    <span className={className} {...props}>
      {isTranslating ? (
        <span className="inline-flex items-center gap-1">
          {text}
          <Loader2 className="w-3 h-3 animate-spin text-amber-400" />
        </span>
      ) : (
        displayText
      )}
    </span>
  );
};

export default TranslatableText;
